import { render, staticRenderFns } from "./PackedModal.vue?vue&type=template&id=3845dfa4&"
import script from "./PackedModal.vue?vue&type=script&lang=js&"
export * from "./PackedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports